/**
 * Created by Akanksha on 5/2/17.
 */

import FetchHelper from '../helpers/fetch_helper';

const HomeownerEligibilityDispatcher = {
  async fetchHomeownerEligibilityData(consentToken) {
    try {
      const homeownerEligibilityDocumentsResponse = await FetchHelper.fetchJson(
        `homeowner/eligibilities/in-person/${consentToken}`,
        { method: 'GET' }
      );
      const { results } = homeownerEligibilityDocumentsResponse;
      this.setStoreVal('customer', results[0].customer);
      this.setStoreVal('user', results[0].user);
      this.setStoreVal('lenderCode', results[0].lenderCode);
      this.setStoreVal('consentToken', consentToken);
      this.setStoreVal('hideHeader', true);
    } catch (error) {
      this.dispatch({
        type: 'handleRequestError',
        data: { error, defaultErrorMessage: 'This link is not valid' },
      });
    }
  },
};

export default HomeownerEligibilityDispatcher;
